<script>
/**
 * The client half of the global "Convert Everything To Caps" setting.
 *
 * The directives below convert what the USER TYPES, so the clerk sees caps as they key. They are
 * NOT the enforcement - a field can only be tagged if somebody remembers to tag it, and the
 * update hook is gated on a `data-user-input` flag, so a value filled in by CODE (the
 * mortgage-company name dropped into Paid By, the Received Of copied across by
 * autoFillCheckPaidBy) was never converted even on a tagged field. That is how Tulsa's receipts
 * printed "firstitle & abstract services llc" and "DAVId ALLEN".
 *
 * The rule is enforced server-side, on save, by src/util/globalCaps.util.js in tmc-local-backend.
 * Use `toCapsIfEnabled` below at any site where code assigns text into a bound field, so what the
 * clerk sees on screen matches what will be stored.
 */
export default {
  computed: {
    /**
     * The county setting, read straight off the store so a component gets it from the mixin
     * alone - most components that need the directive do not otherwise map SystemConfig.
     */
    isEverythingToCaps() {
      const state = (this.$store || {}).state || {};
      return ((state.SystemConfig || {}).globalSettingItem || {}).conEverythingToCaps === true;
    },
  },
  methods: {
    /**
     * Uppercase a value the CODE is about to assign into a bound field, if the setting is on.
     * Non-strings (null from an unmatched dropdown lookup, a number) pass through untouched.
     */
    toCapsIfEnabled(value) {
      return (this.isEverythingToCaps && typeof value === 'string') ? value.toUpperCase() : value;
    },
  },
  directives: {
    uppercase: {
      bind(el) {
        el.addEventListener('input', () => {
          el.setAttribute('data-user-input', 'true');
        });
      },
      update(el, binding) {
        const sourceValue = el.getElementsByTagName('input')[0];
        // the inner input can be absent while Vue is re-patching the field
        if (!sourceValue) return;
        let newValue = sourceValue.value;

        // Only capitalize if it's user input and the binding.value is true
        if (binding.value && el.getAttribute('data-user-input') === 'true') {
          newValue = sourceValue.value.toUpperCase();
        }

        if (sourceValue.value !== newValue) {
          const { selectionStart, selectionEnd } = sourceValue;
          sourceValue.value = newValue;
          sourceValue.setSelectionRange(selectionStart, selectionEnd);
          sourceValue.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Reset the user input flag after update
        el.setAttribute('data-user-input', 'false');
      },
    },
    textAreaUppercase: {
      bind(el) {
        el.addEventListener('input', () => {
          el.setAttribute('data-user-input', 'true');
        });
      },
      update(el, binding) {
        const sourceValue = el.getElementsByTagName('textarea')[0];
        // the inner textarea can be absent while Vue is re-patching the field
        if (!sourceValue) return;
        let newValue = sourceValue.value;

        // Only capitalize if it's user input and the binding.value is true
        if (binding.value && el.getAttribute('data-user-input') === 'true') {
          newValue = sourceValue.value.toUpperCase();
        }

        if (sourceValue.value !== newValue) {
          const { selectionStart, selectionEnd } = sourceValue;
          sourceValue.value = newValue;
          sourceValue.setSelectionRange(selectionStart, selectionEnd);
          sourceValue.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // Reset the user input flag after update
        el.setAttribute('data-user-input', 'false');
      },
    },
  },
};
</script>
